/* tslint:disable */
/* eslint-disable */
/**
 * predictonco-backend API
 * predictonco-backend API
 *
 * The version of the OpenAPI document: 1.0.3
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Publication
 */
export interface Publication {
    /**
     * 
     * @type {string}
     * @memberof Publication
     */
    pubmed: string;
    /**
     * 
     * @type {string}
     * @memberof Publication
     */
    title: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof Publication
     */
    authors: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof Publication
     */
    journal: string;
}

/**
 * Check if a given object implements the Publication interface.
 */
export function instanceOfPublication(value: object): value is Publication {
    if (!('pubmed' in value) || value['pubmed'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('authors' in value) || value['authors'] === undefined) return false;
    if (!('journal' in value) || value['journal'] === undefined) return false;
    return true;
}

export function PublicationFromJSON(json: any): Publication {
    return PublicationFromJSONTyped(json, false);
}

export function PublicationFromJSONTyped(json: any, ignoreDiscriminator: boolean): Publication {
    if (json == null) {
        return json;
    }
    return {
        
        'pubmed': json['pubmed'],
        'title': json['title'],
        'authors': json['authors'],
        'journal': json['journal'],
    };
}

export function PublicationToJSON(json: any): Publication {
    return PublicationToJSONTyped(json, false);
}

export function PublicationToJSONTyped(value?: Publication | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'pubmed': value['pubmed'],
        'title': value['title'],
        'authors': value['authors'],
        'journal': value['journal'],
    };
}

